import React from 'react';
import { Header } from '@/components/layout';
import { useAnalyses } from '@/api/domains/analyses';
import { useDocuments } from '@/api/domains/documents';
import { useDashboardStats } from '../hooks/useDashboardStats';
import {
  WelcomeSection,
  StatsSection,
  QuickActionsSection,
  RecentActivitySection,
  KpiSection
} from '../components';
import styles from '../Dashboard.module.css';

const Dashboard: React.FC = () => {
  const { data: analysesData, isLoading: analysesLoading } = useAnalyses({
    skip: 0,
    limit: 500
  });

  const { data: documentsData, isLoading: documentsLoading } = useDocuments({
    skip: 0,
    limit: 500
  });

  const {
    data: recentAnalyses,
    isLoading: recentLoading,
    error
  } = useAnalyses({
    skip: 0,
    limit: 3
  });

  const dynamicStats = useDashboardStats({
    analysesData,
    documentsData
  });

  return (
    <div className={styles.root}>
      <Header />
      <main className={styles.main}>
        <WelcomeSection />
        <StatsSection
          dynamicStats={dynamicStats}
          isLoading={analysesLoading || documentsLoading}
        />
        <QuickActionsSection />
        <RecentActivitySection
          recentAnalyses={recentAnalyses}
          isLoading={recentLoading}
          error={error}
        />
        <KpiSection
          analysesData={analysesData}
          documentsData={documentsData}
          analysesLoading={analysesLoading}
          documentsLoading={documentsLoading}
          dynamicStats={dynamicStats}
        />
      </main>
    </div>
  );
};

export default Dashboard;
